import { useEffect, useRef } from 'react';
import { runVersionCheck } from '../../services/versionCheckService';

/**
 * Renderless one-shot trigger for the BE-driven minimum-version lifeline.
 *
 * Fires `runVersionCheck()` exactly once per app boot. Previously gated on
 * `isAuthLoading` to wait for auth restore, but with optimistic paint
 * `isLoading` is always false from boot, so the check fires immediately on
 * mount. `/ping` is public and doesn't need auth state anyway; it just
 * races whoami harmlessly (the two endpoints are independent).
 *
 * StrictMode-safe via the inFlight ref — even with React's dev double-
 * invocation of effects, we only call the version check once.
 */
export const VersionCheckRunner: React.FC = () => {
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    void runVersionCheck();
  }, []);

  return null;
};
